<template>
  <div>
    <facit-header></facit-header>
    <div class="profile-div col-12">

      <div style="display: flex;justify-content: space-between;">
        <h5 class="mt-3 mb-3"> <a @click="users()" class="Userlink">
            User Management</a> / User History </h5>

        <div @click="exportData()"> <!-- openModal() -->
          <v-icon style="cursor: pointer;position: relative;top: 10px;right: 15px;" name="download"
            base-class="icon-width" @click="exportData()">
          </v-icon>
        </div>
      </div>

      <br><br>
      <b-table striped hover show-empty empty-text="There is no user history to show" :fields="tableFields"
        :items="history" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
      </b-table>
      <br>
      <b-pagination align="right" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />

      <!-- <b-modal v-model="userSettingsModal" hide-footer title="Data Export">
        <b-form class="ml-4 mr-4 mb-4" data-vv-scope="formRegistration">

          <div style="display: flex;justify-content: space-between;">
            <b-button @click="exportCurrentData" type="submit" variant="warning">Export Current Page Data</b-button>
            <b-button @click="exportData" type="submit" variant="warning">Export All Page Data</b-button>
          </div>

        </b-form>
      </b-modal> -->

    </div>
  </div>
</template>

<script>
import API from '@/api';
import FacitHeader from '@/components/header';
import { excelParser } from "../../excel-parser";

export default {
  name: 'userManagement',
  components: { FacitHeader },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      history: null,
      userAccount: null,
      listData: [],
      currentListData: null,
      userSettingsModal: false,
      tableFields: [
        {
          key: 'mac',
          label: 'MAC Address',
          sortable: true,
        },
        // {
        //   key: 'host',
        //   label: 'Host Name',
        //   sortable: true,
        // },
        {
          key: 'timestamp',
          label: 'Date',
          sortable: true,
          formatter: (value) => {
            const fullDate = new Date(value);
            let day = fullDate.getDate();
            let month = fullDate.getMonth() + 1;
            const year = fullDate.getFullYear();
            const hour = fullDate.getHours();
            const min = fullDate.getMinutes();
            const sec = fullDate.getSeconds();
            if (day < 10) { day = `0${day}`; }
            if (month < 10) { month = `0${month}`; }
            return `${day}-${month}-${year}  ${hour}:${min}:${sec}`;
          },
        },
        {
          key: 'length',
          label: 'Video Length',
          sortable: true,
        },
        {
          key: 'version',
          label: 'Version',
          sortable: false,
        },
      ],
    };
  },
  async created() {
    const userId = this.$route.query.id;
    this.getHistory(userId);
  },
  methods: {
    async onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      // this.currentPage = 1
    },
    async getHistory(userId) {
      // this.history = await API.get(`Accounts/${userId}/?filter={"include": ["devices", "HistoryExports"]}`);

      this.userAccount = await API.get(`Accounts/${userId}`);

      this.history = await API.get(`/HistoryExports?filter={"where":{"clientId":"${userId}"}}`)

      function custom_sort(a, b) {
        return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
      }

      this.history.sort(custom_sort);

      const history = this.history.historyExport;

      try {
        this.history = history.map((h) => {
          const device = this.history.devices.find(d => d.macAddress === h.mac);
          if (device) {
            return { ...h, host: device.hostname };
          }
          else {
            return { ...h, host: '' };
          }
        });
      } catch (e) { }

      // For Export Excel File
      Object.assign(this.listData, this.history);

      this.listData = this.listData.map((res) => {
        return { 'Mac Address': res.mac, 'Date': res.timestamp, 'Video Length': res.length, 'Version': res.version }
      })

      this.currentListData = this.history.slice(0, 10);

    },
    // async openModal() {
    //   this.userSettingsModal = true;
    // },
    exportData() {
      excelParser().exportDataFromJSON(this.listData, 'user-history', null);
    },
    exportCurrentData() {
      excelParser().exportDataFromJSON(this.currentListData, 'user-history', null);
    },
    users() {
      this.$router.push('/admin/users');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked+.slider {
  background-color: #d6700a;
}

input:focus+.slider {
  box-shadow: 0 0 1px #d6700a;
}

input:checked+.slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 20px;
}

.switch input {
  display: none;
}

.icon-width {
  width: 20px !important;
  height: 20px !important;
}

.page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #6610f2 !important;
  border-color: #6610f2 !important;
}

.profile-div {
  margin-top: 50px;
  margin-left: 50px;
  width: 95% !important;
}

.Userlink {
  color: #df8031 !important;
  text-decoration: none !important;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/userHistory.vue